/**
 * Standard labels used for PIXI containers and graphics in drawing-core.
 *
 * Consistent labeling enables:
 * - Finding children by label
 * - Event delegation
 * - Debugging in Pixi DevTools
 */
export const Labels = {
	/** Label for the background image/container layer */
	BACKGROUND_CONTAINER: 'background-container',

	/** Label for the background defocus overlay */
	BACKGROUND_DEFOCUS: 'background-defocus',

	/** Label for the master drawing/image sprite */
	MASTER_IMAGE: 'hitl-master-image',

	/**
	 * Label for the high-resolution page tile drawn over the master image while
	 * zoomed in. Part of the plan imagery, so the defocus overlay sits above it.
	 */
	PAGE_DETAIL_TILE: 'hitl-page-svg-detail',

	/** Prefix for line graphics: "line|0", "line|1", etc. */
	LINE_PREFIX: 'line',

	/** Prefix for point graphics: "point|0", "point|1", etc. */
	POINT_PREFIX: 'point',

	/** Label for polygon fill graphics */
	POLYGON_FILL: 'polygon-fill',

	/** Label for overlay container (hover effects) */
	OVERLAY: 'overlay',

	/** Label for hover outline graphics */
	OUTLINE: 'outline',

	/** Label for area measurement text */
	AREA_MEASUREMENT: 'area-measurement',

	/** Label for the inspect select tool's overlay container and its graphic */
	INSPECT_SELECT_OVERLAY: 'inspect-select-overlay',
} as const;
